<template>
    <div>
      <div class="modal hide fade" id="modalOnHandDetail" tabindex="-1" role="dialog" aria-labelledby="modalOnHandDetail" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">On Hand Detail Lists</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <dl class="row dl-custom">
                    <dt class="col-md-4">Serial Number</dt>
                    <dd class="col-md-8">{{ onHandDetail.serial_number }}</dd>

                    <dt class="col-md-4">Hand No.</dt>
                    <dd class="col-md-8">{{ onHandDetail.hand_no }}</dd>

                    <dt class="col-md-4">Date</dt>
                    <dd class="col-md-8">{{ onHandDetail.hand_date | dateFormat('DD/MM/YYYY') }}</dd>

                    <dt class="col-md-4">Serial Number</dt>
                    <dd class="col-md-8">{{ onHandDetail.serial_number }}</dd>
                  </dl>
                </div>
                <div class="col-md-6">
                  <dl class="row dl-custom">
                    <dt class="col-md-4">Product</dt>
                    <dd class="col-md-8"><b>[{{ onHandDetail.product_no }}]</b> {{ onHandDetail.product_description }}</dd>

                    <dt class="col-md-4">Ukuran Potong</dt>
                    <dd class="col-md-8">{{ onHandDetail.qty_stock }} {{ onHandDetail.uom_stock }}</dd>

                    <dt class="col-md-4">Dipakai</dt>
                    <dd class="col-md-8">{{ onHandDetail.manufactures.length }}</dd>
                  </dl>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-item table-sm table-striped table-hover">
                      <thead>
                        <th>Manufacture No.</th>
                        <th>Date</th>
                        <th>Qty</th>
                        <th>Uom</th>
                      </thead>
                      <tbody>
                        <tr v-for="d in onHandDetail.manufactures" :key="d.id">
                          <td>{{ d.manufacture_no }}</td>
                          <td>{{ d.manufacture_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ d.hand_qty }}</td>
                          <td>{{ d.hand_uom_id }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ onHandDetail }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'InventoryOnHandDetailModal',
  computed: {
    ...mapState({
      onHandDetail: state => state.inventories.onHandDetail
    })
  }
}
</script>
